/**
 * Simple Label UI Component
 * Basic implementation for forms
 */

import React, { LabelHTMLAttributes, forwardRef } from 'react';

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className = '', ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={`label ${className}`}
        {...props}
      />
    );
  }
);
Label.displayName = 'Label';
